/**
 * The library, newest first (block 03).
 *
 * An infinite query rather than a paged one: the list is a scroll, and every
 * client renders it as one. `filters` is threaded through from here so block 19
 * adds no hook — it adds fields to `NookFilters` and nothing else.
 */
import { useInfiniteQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { processingRefetch } from "../processing.js";
import { queryKeys } from "../query-keys.js";
// Outside the query key, so the optimistic insert into `nooks.list()` still lands.
const PAGE_SIZE = 24;
export function useNooks(filters, options = {}) {
    return useInfiniteQuery({
        enabled: options.enabled ?? true,
        queryKey: queryKeys.nooks.list(filters),
        queryFn: ({ pageParam }) => getNookClient().listNooks({ limit: PAGE_SIZE, ...filters, cursor: pageParam }),
        initialPageParam: null,
        getNextPageParam: (last) => last.nextCursor,
        // The library settles from `processing` to `ready` on its own, with no
        // manual refresh (block 08). Loaded pages are refetched together, which is
        // why this stops the moment nothing is processing. Otherwise it falls back
        // to a 2-minute background poll, or the caller's `options.refetchInterval`.
        refetchOnWindowFocus: true,
        refetchInterval: (query) => processingRefetch(query.queryHash, query.state.dataUpdateCount, (query.state.data?.pages ?? []).some((page) => page.items.some((item) => item.status === "processing"))) || (options.refetchInterval ?? 2 * 60_000),
    });
}
//# sourceMappingURL=use-nooks.js.map